import React, { useState } from 'react';
import { Image, View, StyleSheet, TouchableOpacity } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';
import { useSelector } from 'react-redux';
import type { RootState } from '../redux/store';
import { apiLink } from '../Common/common';

interface Props {
  edId?: number;
  uri?: string; // local file (not yet uploaded)
  size?: number;
  onRemove?: () => void;
  onPress?: () => void;
}

/** Thumbnail for a saved am_edocument photo (edId, fetched with the auth header) or a local file uri. */
const AmPhoto = ({ edId, uri, size = 64, onRemove, onPress }: Props) => {
  const token = useSelector((state: RootState) => state.gdata.token);
  const [failed, setFailed] = useState(false);
  const source = failed ? undefined : uri
    ? { uri }
    : edId
      ? { uri: `${apiLink}amdocument/download/${edId}`, headers: { auth: `${token}` } }
      : undefined;

  return (
    <TouchableOpacity activeOpacity={onPress ? 0.7 : 1} onPress={onPress} style={{ width: size, height: size }}>
      <View style={[styles.box, { width: size, height: size }]}>
        {source ? (
          <Image source={source} style={{ width: size, height: size }} resizeMode="cover" onError={() => setFailed(true)} />
        ) : (
          <Icon name="image" size={size / 3} color="#bbb" />
        )}
      </View>
      {onRemove ? (
        <TouchableOpacity style={styles.remove} onPress={onRemove}>
          <Icon name="times" size={11} color="#fff" />
        </TouchableOpacity>
      ) : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  box: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: '#ddd',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fafafa'
  },
  remove: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: 'rgba(0,0,0,0.6)',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export default AmPhoto;
